import React, { useContext, useState } from 'react';

import { TabsAttr } from '../../../components/misc/SideNav';
import TabNav from '../../../components/navigation/TabNav';
import { DetailProductContext } from '../DetailProductContainer';
import Labels from './Labels';
import Processed from './Processed';
import ProcessedGeneral from './ProcessedGeneral';

//"MENU", "ADDON", "STOCK", "COMBO", "MANUFACTURED"
const ProcessedAndLabels = () => {
  const { product } = useContext(DetailProductContext)

  const [currentTab, setCurrentTab] = useState('proc')

  const tabs: TabsAttr[] = [
    {
      name: 'Áreas de procesado',
      href: 'proc',
      current: currentTab === 'proc',
    },
  ]
  if (product?.type !== 'MANUFACTURED') {
    tabs.push({
      name: 'Producción/Etiquetas',
      href: 'labels',
      current: currentTab === 'labels',
    })
  }
  if (['MENU', 'MANUFACTURED', 'STOCK'].includes(product!.type)) {
    tabs.push({
      name: 'Generales',
      href: 'general',
      current: currentTab === 'general',
    })
  }

  return (
    <div>
      <TabNav action={(tab: string) => setCurrentTab(tab)} tabs={tabs} />

      {currentTab === 'proc' && <Processed />}
      {currentTab === 'labels' && <Labels />}
      {currentTab === 'general' && <ProcessedGeneral />}
    </div>
  )
}

export default ProcessedAndLabels
